module.exports = __webpack_public_path__ + "static/media/dumper_demo.bb4141fd.gif";